import React, {Component} from 'react'
import i18next from 'i18next';

import styled from '@emotion/styled'
import sv from '../../styles/styles'

import VideoThumbnail from '../VideoThumbnail'
import {sourceConstants} from "../../_constants";

// STYLE ##########################################################

const Container = styled(`div`)`
  transition: background .2s ease-out;
  flex: 0;
  cursor: pointer;
  padding: 12px 24px;
  margin: 4px 0px;
  border-radius: 5px;
  ${sv.flexRow};
  &:hover {
    background: ${sv.colors.hover};
  }
`;

const Info = styled(`div`)`
  flex: 1;
  margin-left: 8px;
`;

const Name = styled(`div`)`
  ${sv.h4};
`;

const Sub = styled(`div`)`
  ${sv.label};
  text-transform: none;
  color: ${sv.colors.grey};
`;

// COMPONENT ##########################################################

class MediaList extends Component {
  render() {
    const t = i18next.t;
    const item = this.props.item;

    const subText = () => {
      let itemSubText;
      if (item.status === sourceConstants.SOURCE_STATE.ACTIVE) {
        itemSubText = t("Viewed", {viewCount: item.viewed});
      } else if (item.status === sourceConstants.SOURCE_STATE.DEACTIVATED) {
        itemSubText = t("Created", {uploadTimeAgo: item.uploaded});
      } else {
        itemSubText = t("Ordered", {uploadTimeAgo: item.uploaded});
      }
      return itemSubText;
    };

    return (
      <Container className={this.props.selectedItem.id === item.id ? 'selectedItem' : 'nop'} onClick={this.props.selectItem}>
        <VideoThumbnail maxWidth={80} image={item.stickerUrl} altText={item.title} />
        <Info>
          <Name>{item.name}</Name>
          <Sub>{subText()}</Sub>
        </Info>
      </Container>
    )
  };

}

export default MediaList
